import React, { useMemo } from "react";
import '../styles/ProductList.css';

const CategoryList = ({ category, products, onSelectGroup, onBack }) => {
  // Obtener grupos para la categoría seleccionada
  const groups = useMemo(() => {
    return [...new Set(
      products
        .filter(product => product.category === category && product.group)
        .map(product => product.group)
    )];
  }, [products, category]);

  return (
    <div className="group-list">
      <div className="breadcrumb">
        <button className="nav-button" onClick={onBack}>
          ← Volver a Categorías
        </button>
        <span className="breadcrumb-separator">/</span>
        <span>{category}</span>
      </div>

      <div className="group-selector">
        <h2>Grupos de {category}</h2>
        {groups.length === 0 ? (
          <p>No hay grupos disponibles para {category}.</p>
        ) : (
          <div className="grid-container">
            {groups.map((group) => (
              <div
                key={group}
                className="grid-item group-item"
                onClick={() => onSelectGroup(group)}
              >
                <h3>{group}</h3>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CategoryList;